import React from 'react';
import createComponentPlugin from '../../pluginFactories/createComponentPlugin';
export default {
    paragraph: createComponentPlugin({
        type: 'PARAGRAPH/PARAGRAPH',
        object: 'block',
        addToolbarButton: false,
        addHoverButton: false,
        deserialize: {
            tagName: 'p',
        },
        Component: function (_a) {
            var children = _a.children, data = _a.data;
            return React.createElement("p", { style: { textAlign: data.get('align') } }, children);
        },
    }),
};
//# sourceMappingURL=index.js.map